module.exports = __webpack_public_path__ + "static/media/WoodElf.e0ba0905.png";